var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Item \xE2\x86\x92 SVG",
    clipPath: "url(#clip0_17_2798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Border_Arrow_Right",
    d: "M14.5296 7.15679L7.99551 0.622711C7.9072 0.534393 7.79133 0.491107 7.6759 0.491979C7.67241 0.491979 7.66979 0.490234 7.66627 0.490234H1.10769C0.866326 0.490234 0.670464 0.686132 0.670464 0.927461C0.670464 0.93095 0.672209 0.933567 0.672209 0.937092C0.671773 1.05252 0.715059 1.16839 0.802941 1.25671L7.03183 7.4856L0.78982 13.7276C0.614494 13.9029 0.614494 14.1871 0.78982 14.3624C0.893875 14.4665 1.03511 14.5011 1.1702 14.4818H7.60241C7.7375 14.501 7.87874 14.4665 7.98279 14.3624L14.5291 7.81612C14.6201 7.72518 14.6616 7.60536 14.6581 7.486C14.6616 7.36752 14.6201 7.24772 14.5296 7.15679ZM7.46862 13.6074H2.17979L7.97054 7.81659C8.06148 7.72566 8.10302 7.60583 8.09953 7.48647C8.10302 7.36755 8.06148 7.24772 7.97054 7.15679L2.17891 1.36469H7.46993L13.5908 7.48556L7.46862 13.6074Z",
    fill: "#F8B232"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_2798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.658325 0.488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYArrow);
export default __webpack_public_path__ + "static/media/YArrow.5cb6dc4199246b9b2fb8e8f6f051884d.svg";
export { ForwardRef as ReactComponent };